import { Icon } from '@chakra-ui/react';

export default function NoteTextIcon(props) {
  return (
    <Icon
      width='16'
      height='15'
      viewBox='0 0 16 15'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M2.66406 14.5625C1.03125 14.5625 0.210938 13.7578 0.210938 12.1406V2.60156C0.210938 0.984375 1.03125 0.179688 2.66406 0.179688H13.3359C14.9688 0.179688 15.7812 0.992188 15.7812 2.60156V12.1406C15.7812 13.75 14.9688 14.5625 13.3359 14.5625H2.66406ZM2.54688 13.3047H13.4375C14.1328 13.3047 14.5234 12.9375 14.5234 12.2109V4.84375C14.5234 4.125 14.1328 3.75 13.4375 3.75H2.54688C1.85156 3.75 1.46875 4.125 1.46875 4.84375V12.2109C1.46875 12.9375 1.85156 13.3047 2.54688 13.3047ZM3.90625 6.65625C3.61719 6.65625 3.41406 6.4375 3.41406 6.16406C3.41406 5.89844 3.61719 5.69531 3.90625 5.69531H12.1094C12.3828 5.69531 12.5938 5.89844 12.5938 6.16406C12.5938 6.4375 12.3828 6.65625 12.1094 6.65625H3.90625ZM3.90625 9.00781C3.61719 9.00781 3.41406 8.80469 3.41406 8.53906C3.41406 8.25781 3.61719 8.04688 3.90625 8.04688H12.1094C12.3828 8.04688 12.5938 8.25781 12.5938 8.53906C12.5938 8.80469 12.3828 9.00781 12.1094 9.00781H3.90625ZM3.90625 11.3594C3.61719 11.3594 3.41406 11.1562 3.41406 10.8906C3.41406 10.6172 3.61719 10.3984 3.90625 10.3984H9.11719C9.39062 10.3984 9.60156 10.6172 9.60156 10.8906C9.60156 11.1562 9.39062 11.3594 9.11719 11.3594H3.90625Z'
        fill='#808080'
      />
    </Icon>
  );
}
